import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Nota: Em um ambiente de produção, essas credenciais devem ser armazenadas em variáveis de ambiente
const firebaseConfig = {
  apiKey: "AIzaSyCNEbr7Ukj5s52tKPWOJqeJFU4O0YDA7EA",
  authDomain: "agendamentos-505a2.firebaseapp.com",
  projectId: "agendamentos-505a2",
  storageBucket: "agendamentos-505a2.firebasestorage.app",
  messagingSenderId: "671665933114",
  appId: "1:671665933114:web:b4663b55c5eed9511b9e03",
  measurementId: "G-4X2TQZQ7B1"
};

// Inicialização do Firebase
const app = initializeApp(firebaseConfig);

// Exportação das instâncias principais
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const firebaseApp = app; // Exportar a instância do app para uso em outros módulos

// Funções de utilidade para formatação de dados do Firestore
export const formatTimestamp = (timestamp) => {
  if (!timestamp) return null;
  if (timestamp.toDate) {
    return timestamp.toDate();
  }
  return timestamp;
};

export const formatDocument = (doc) => {
  if (!doc) return null;
  
  const data = doc.data();
  if (!data) return null;
  
  return {
    id: doc.id,
    ...data,
    createdAt: formatTimestamp(data.createdAt),
    updatedAt: formatTimestamp(data.updatedAt),
  };
}; 